module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-06-ff64ed3cd5af57f52e3372c2230486cc.jpg";